import ACTION_TYPES from "../types";

// reducer.js
const INITIAL_STATE = {
	notes: null,
    NoteCategory:'sheet',
	selectedCell:"",
	selectedRow:"",
	selectionSource: null,
	cellNotes:"",
	rowNotes:"",
	updatedNotesTimeStamp:"",
	sheetNotes:"",
	notifications:new Map(),
	sharedByMeNotifications:new Map(),
	accessInfo:new Map(),
	calendarEvents:[],
	accessInfoById:[],
	accessInfoByIdForSharedSheet:[],
	isOneDriveConnected:false,
	takeOneDriveBackup:false,
	workbooksSyncedWithOneDrive:new Map(),
	backupAllWorkbookstoOneDrive:false,
	WorkBookUploadCallInProgress:false,
	sharedWithMeSheets:[],
	defaultEventType:'Meeting',
	selectedEventNode:null,
	sharedLists:[],
	updateSheetOfWorkbookOnOnedrive:false,
	resetIsSheetUpdatedRefAfterInactivity : false,
	isNotificationAccessReceived:true,
	isUserActivityAlreadyInDb : false,
	isSheetShareStart: false,
	ischeckInAgentRowsToBeMerged : false,
	fallbackerror : null,
	isOneDriveServiceWorking : true,
	triggerSaveExternally : false,
	hasOriginalTemplateShareAccess : false,
	isAzureDevOpsConnected:false,
}

export default (state = INITIAL_STATE, action) => {
	switch(action.type) {
		case ACTION_TYPES.GET_NOTES:
			return {
				...state,
				notes: state.notes,
                NoteCategory:state.NoteCategory
			}
		case ACTION_TYPES.SET_NOTES:
			return {
				...state,
				notes: action.notes,
                NoteCategory:action.NoteCategory
			}
		case ACTION_TYPES.SET_UPDATED_TIME:
			return {
				  ...state,
				  updatedNotesTimeStamp: action.updatedNotesTimeStamp  // Update time in state
			}
		case ACTION_TYPES.SET_USER_ACTIVITY_INFO:
			return{
				...state,
				notes: action.notes || state.notes,
                NoteCategory:action.NoteCategory || state.NoteCategory,
				selectedCell:action.selectedCell==""? action.selectedCell:action.selectedCell || state.selectedCell,
				selectedRow:(action.selectedRow==''||action.selectedRow)?action.selectedRow : state.selectedRow,
				selectionSource: action.selectionSource,
				cellNotes:action.cellNotes || state.cellNotes,
				rowNotes:action.rowNotes || state.rowNotes,
				sheetNotes:action.sheetNotes || state.sheetNotes,
				notifications:action.notifications || state.notifications,
				sharedByMeNotifications:action.sharedByMeNotifications||state.sharedByMeNotifications,
				accessInfo:action.accessInfo || state.accessInfo,
				accessInfoById:action.accessInfoById||state.accessInfoById,
				takeOneDriveBackup: (action.takeOneDriveBackup || action.takeOneDriveBackup === false) ? action.takeOneDriveBackup : state.takeOneDriveBackup,
				workbooksSyncedWithOneDrive: action.workbooksSyncedWithOneDrive || state.workbooksSyncedWithOneDrive,
				isOneDriveConnected:(action.isOneDriveConnected || action.isOneDriveConnected===false)?action.isOneDriveConnected : state.isOneDriveConnected,
				backupAllWorkbookstoOneDrive:action.backupAllWorkbookstoOneDrive!==undefined?action.backupAllWorkbookstoOneDrive : state.backupAllWorkbookstoOneDrive,
				sharedWithMeSheets:action.sharedWithMeSheets||state.sharedWithMeSheets,				
				WorkBookUploadCallInProgress:action.WorkBookUploadCallInProgress!==undefined?action.WorkBookUploadCallInProgress : state.WorkBookUploadCallInProgress,
				defaultEventType:action.defaultEventType || state.defaultEventType,
				selectedEventNode:action.selectedEventNode ,
				sharedLists:action.sharedLists || state.sharedLists,
				hasOriginalTemplateShareAccess: (action.hasOriginalTemplateShareAccess || action.hasOriginalTemplateShareAccess===false)?action.hasOriginalTemplateShareAccess : state.hasOriginalTemplateShareAccess
			}
		case ACTION_TYPES.SET_CALENDAR_EVENTS:
			return {
				...state,
				calendarEvents: action.payload || state.calendarEvents
			}
		case ACTION_TYPES.SET_FLAGTOUPDATESHEETONONEDRIVE:
			return {
				...state,
				updateSheetOfWorkbookOnOnedrive: action.updateSheetOfWorkbookOnOnedrive
			}
		case ACTION_TYPES.SET_RESETISSHEETUPDATEDREFAFTERINACTIVITY:
			return {
				...state,
				resetIsSheetUpdatedRefAfterInactivity: action.resetIsSheetUpdatedRefAfterInactivity
			}
		case ACTION_TYPES.SET_NOTIFICATION_DATA:
			return {
				...state,
				isNotificationAccessReceived: action.isNotificationAccessReceived
			}
		case ACTION_TYPES.SET_SHARED_SHEET_ACCESS:
			return {
				...state,
				accessInfoByIdForSharedSheet:action.accessInfoByIdForSharedSheet||state.accessInfoByIdForSharedSheet,
			}
		case ACTION_TYPES.SET_ISUSERACTIVITYALREADYINDB : 
		return {
			...state,
			isUserActivityAlreadyInDb : action.isUserActivityAlreadyInDb
		}
		case ACTION_TYPES.SET_IS_SHEET_SHARE_START:
			return {
				  ...state,
				  isSheetShareStart: action.isSheetShareStart 
			}

		case ACTION_TYPES.SET_IS_CHECKINAGENT_ROWS_TO_BE_MERGED:
			return {
				...state,
				ischeckInAgentRowsToBeMerged: action.ischeckInAgentRowsToBeMerged
			}
		case ACTION_TYPES.SET_FALLBACKERROR:
			return {
				...state,
				fallbackerror: action.fallbackerror
			}
		case ACTION_TYPES.SET_ISONEDRIVESERVICEWORKING:
			return {
				...state,
				isOneDriveServiceWorking : action.isOneDriveServiceWorking
			}
			case ACTION_TYPES.SET_TRIGGERSAVE:
				return {
					...state,
					triggerSaveExternally : action.triggerSaveExternally
				}
				case ACTION_TYPES.SET_ISAZUREDEVOPS_CONNECTED:
					return {
						...state,
						isAzureDevOpsConnected : action.isAzureDevOpsConnected
					}
		default:
			return state;
	}
};